import React from 'react';

const Navbar = ({ setCurrentPage, cartItemCount }) => {
  return (
    <header className="sticky top-0 z-50 bg-white shadow-sm px-4 py-3">
      <div className="container mx-auto flex justify-between items-center">
        <h1 
          className="text-3xl md:text-4xl font-bold cursor-pointer" 
          style={{ fontFamily: "'Times New Roman', serif" }}
          onClick={() => setCurrentPage('home')}
        >
          VELNO
        </h1>
        <nav className="flex space-x-3 sm:space-x-6 text-sm sm:text-base">
          <button onClick={() => setCurrentPage('tshirts')} className="text-gray-800 hover:text-gray-600 transition-colors">Camisetas</button>
          <button onClick={() => setCurrentPage('hoodies')} className="text-gray-800 hover:text-gray-600 transition-colors">Hoodies</button>
          <button onClick={() => setCurrentPage('about')} className="text-gray-800 hover:text-gray-600 transition-colors">Nosotros</button>
        </nav>
        <div className="flex items-center space-x-3">
          <button onClick={() => setCurrentPage('cart')} className="relative p-1 md:p-2 rounded-full hover:bg-gray-100 transition-colors">
            <svg className="w-5 h-5 md:w-6 md:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 11V7a4 4 0 00-8 0v4M5 9h14l1 12H4L5 9z"></path>
            </svg>
            {cartItemCount > 0 && (
              <span className="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-red-100 bg-red-600 rounded-full">
                {cartItemCount}
              </span>
            )}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;